import Login from './Login';

export default Login;


// WEBPACK FOOTER //
// ./src/components/pages/Login/index.js